<template>
  <base-table :data="getLogsOCPP">
    <el-table-column
      prop="id"
      :label="$t('sections.logs.table.id')"
      width="150%"
    />
    <el-table-column
      prop="messageType"
      :label="$t('sections.logs.table.messageType')"
      width="180%"
    />
    <el-table-column
      prop="direction"
      :label="$t('sections.logs.table.direction')"
      width="150%"
    />
    <el-table-column :label="$t('sections.logs.table.dateTime')" width="220%">
      <template slot-scope="props">
        {{
          props.row.timestamp
            ? formatTime(props.row.timestamp)
            : props.row.timestamp
        }}
      </template>
    </el-table-column>
    <el-table-column prop="logs" :label="$t('sections.logs.table.logs')" />
  </base-table>
</template>
<script>
import { formatTime } from '@/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'LogsTableOCPP',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getLogsOCPP']),
  },
  methods: {
    formatTime,
  },
};
</script>
<style lang="scss" scoped></style>
